module.exports = __webpack_public_path__ + "img/pic_yhebfs@2x.e1d8c08c.png";